import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const LoadingPlugin = {
  install(Vue) {
    Vue.use(Loading, {
      color: '#2dce89',
      backgroundColor: '#ffffff',
      opacity: 0.3,
      zIndex: 9999,
    });

    const $loader = {
      active: true,
      maxLength: 3,
      stack: [],
      enable: () => {
        $loader.active = true;
      },
      disable: () => {
        $loader.active = false;
      },

      show: () => {
        if ($loader.active && $loader.stack.length < 3) {
          $loader.stack.push(Vue.$loading.show());
        }
      },
      hide: () => {
        if ($loader.active && $loader.stack.length > 0) {
          $loader.stack.pop().hide();
        }
      },
    };

    Vue.axios.interceptors.request.use(
      function (config) {
        $loader.show();
        return config;
      },
      function (error) {
        $loader.hide();
        return Promise.reject(error);
      }
    );

    Vue.axios.interceptors.response.use(
      function (response) {
        $loader.hide();
        return response;
      },
      function (error) {
        $loader.hide();
        return Promise.reject(error);
      }
    );

    Vue.prototype.$loader = $loader;
  },
};

export default LoadingPlugin;
